import {
  GET_NBVISITE_REQUEST,
  GET_NBVISITE_SUCCESS,
  GET_NBVISITE_ERROR,
  GET_TOP3CATEG_REQUEST,
  GET_TOP3CATEG_SUCCESS,
  GET_TOP3CATEG_ERROR,
  GET_RESETSTATSMONTHLY_REQUEST,
  GET_RESETSTATSMONTHLY_SUCCESS,
  GET_RESETSTATSMONTHLY_ERROR,
  GET_ARRAYVISITEYEARS_REQUEST,
  GET_ARRAYVISITEYEARS_SUCCESS,
  GET_ARRAYVISITEYEARS_ERROR,
} from "./actions";

const initialState = {
  nbVisiteRequest: false,
  nbVisiteSuccess: false,
  nbVisiteError: false,
  nbVisiteWebSite: undefined,

  top3CategRequest: false,
  top3CategSuccess: false,
  top3CategError: false,
  top3Categ: undefined,

  arrayVisiteYearsRequest: false,
  arrayVisiteYearsSuccess: false,
  arrayVisiteYearsError: false,
  arrayVisiteYears: undefined,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_NBVISITE_REQUEST:
      return {
        ...state,
        nbVisiteRequest: true,
        nbVisiteSuccess: false,
        nbVisiteWebSite: action,
        nbVisiteError: false,
      };

    case GET_NBVISITE_SUCCESS:
      return {
        ...state,
        nbVisiteRequest: false,
        nbVisiteSuccess: true,
        nbVisiteWebSite: action.nbVisite,
        nbVisiteError: false,
      };

    case GET_NBVISITE_ERROR:
      return {
        ...state,
        nbVisiteRequest: false,
        nbVisiteSuccess: false,
        nbVisiteWebSite: undefined,
        nbVisiteError: action.error,
      };

    case GET_TOP3CATEG_REQUEST:
      return {
        ...state,
        top3CategRequest: true,
        top3CategSuccess: false,
        top3Categ: action,
        top3CategError: false,
      };

    case GET_TOP3CATEG_SUCCESS:
      return {
        ...state,
        top3CategRequest: false,
        top3CategSuccess: true,
        top3Categ: action.top3Categ,
        top3CategError: false,
      };

    case GET_TOP3CATEG_ERROR: {
      return {
        ...state,
        top3CategRequest: false,
        top3CategSuccess: false,
        top3Categ: undefined,
        top3CategError: true,
      };
    }

    case GET_RESETSTATSMONTHLY_REQUEST: {
      return {
        ...state,
      };
    }

    case GET_RESETSTATSMONTHLY_SUCCESS: {
      return {
        ...state,
      };
    }

    case GET_RESETSTATSMONTHLY_ERROR: {
      return {
        ...state,
      };
    }

    case GET_ARRAYVISITEYEARS_REQUEST: {
      return {
        ...state,
        arrayVisiteYearsRequest: true,
        arrayVisiteYearsSuccess: false,
        arrayVisiteYears: undefined,
        arrayVisiteYearsError: false,
      };
    }

    case GET_ARRAYVISITEYEARS_SUCCESS:
      return {
        ...state,
        arrayVisiteYearsRequest: false,
        arrayVisiteYearsSuccess: true,
        arrayVisiteYears: action.arrayVisiteYears,
        arrayVisiteYearsError: false,
      };

    case GET_ARRAYVISITEYEARS_ERROR: {
      return {
        ...state,
        arrayVisiteYearsRequest: false,
        arrayVisiteYearsSuccess: false,
        arrayVisiteYears: undefined,
        arrayVisiteYearsError: true,
      };
    }

    default:
      return state;
  }
};
export default reducer;



// WEBPACK FOOTER //
// ./src/pages/admin/stats/reducer.js